import { render, staticRenderFns } from "./alertNotifications.vue?vue&type=template&id=2a079668&scoped=true"
import script from "./alertNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./alertNotifications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alertNotifications.vue?vue&type=style&index=0&id=2a079668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a079668",
  null
  
)

export default component.exports